if (!customElements.get('pdp-selling-plans')) {
  customElements.define(
    'pdp-selling-plans',
    class PDPSellingPlans extends HTMLElement {
      debug(...args) {
        if (!window.PDP_SP_DEBUG) return;
        console.log('[pdp-selling-plans]', ...args);
      }

      connectedCallback() {
        this.setup();
      }

      setup() {
        if (this.isSettingUp) return;
        this.isSettingUp = true;

        this.productInfo = this.closest('product-info');
        this.formId = this.dataset.formId;
        this.form =
          (this.formId ? document.getElementById(this.formId) : null) ||
          this.productInfo?.querySelector('form[is="product-form"]') ||
          null;

        this.optionInputs = Array.from(this.querySelectorAll('.pdp-selling-plans__input'));
        if (!this.optionInputs.length) {
          this.isSettingUp = false;
          return;
        }

        if (this.form) {
          this.planInput = this.form.querySelector('input[name="selling_plan"]');
          if (!this.planInput) {
            this.planInput = document.createElement('input');
            this.planInput.type = 'hidden';
            this.planInput.name = 'selling_plan';
            this.form.appendChild(this.planInput);
          }
        } else {
          this.planInput = null;
        }

        this.optionInputs.forEach((input) => {
          if (input.dataset.pdpPlansBound === 'true') return;
          input.addEventListener('change', () => this.handleSelectionChange(input));
          input.dataset.pdpPlansBound = 'true';
        });

        const currentPlanValue = this.planInput && this.planInput.value ? String(this.planInput.value) : '';
        const previousSelectedIndex = Number.parseInt(this.dataset.selectedIndex || '', 10);
        const checkedFromMarkup = this.optionInputs.find((input) => input.checked) || null;
        const matchingInput = currentPlanValue
          ? this.optionInputs.find((input) => String(input.value) === currentPlanValue)
          : null;
        const indexedInput =
          Number.isInteger(previousSelectedIndex) && this.optionInputs[previousSelectedIndex]
            ? this.optionInputs[previousSelectedIndex]
            : null;
        const checkedInput = checkedFromMarkup || matchingInput || indexedInput || this.optionInputs[0];

        if (this.productInfo?.dataset?.pdpPurchaseMode === 'one-time') {
          this.optionInputs.forEach((input) => {
            input.checked = false;
          });
          this.handleSelectionChange(null);
          this.isSettingUp = false;
          return;
        }

        this.optionInputs.forEach((input) => {
          input.checked = input === checkedInput;
        });
        this.handleSelectionChange(checkedInput);

        this.isSettingUp = false;
      }

      handleSelectionChange(activeInput) {
        this.optionInputs.forEach((input) => {
          const option = input.closest('.pdp-selling-plans__option');
          if (!option) return;
          option.classList.toggle('is-selected', input === activeInput);
        });

        if (this.planInput) {
          this.planInput.value = activeInput?.value || '';
        }

        const selectedIndex = this.optionInputs.indexOf(activeInput);
        this.dataset.selectedIndex = String(selectedIndex);

        if (!activeInput) {
          this.productInfo?.dispatchEvent(
            new CustomEvent('pdp:purchase-mode-changed', {
              bubbles: true,
            })
          );
          return;
        }

        const oneTimeButton = this.productInfo?.querySelector('.pdp-one-time-purchase__button');
        if (oneTimeButton) {
          oneTimeButton.classList.remove('is-selected');
        }

        if (this.productInfo) {
          this.productInfo.dataset.pdpPurchaseMode = 'subscription';
          this.productInfo.dispatchEvent(
            new CustomEvent('pdp:purchase-mode-changed', {
              bubbles: true,
            })
          );
        }
      }
    }
  );
}
